export default "__VITE_ASSET__CeQyg1jO__"